import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ModalIaResultsResumePageRoutingModule } from './modal-ia-results-resume-routing.module';
import { ModalIaResultsResumePage } from './modal-ia-results-resume.page'
import { HttpClientModule } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator'; 
import { FilterResumeResultsByDatePageModule } from '../filter-resume-results-by-date/filter-resume-results-by-date.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalIaResultsResumePageRoutingModule,
    HttpClientModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    FilterResumeResultsByDatePageModule,
  ],
  declarations: [ModalIaResultsResumePage]
})
export class ModalIaResultsResumePageModule {}
